import { Pipe, PipeTransform, inject } from '@angular/core';
import { ActivityInterface } from '@vendasta/crm';
import { CrmFieldService, SystemFieldIds } from '../shared-services/crm-services/field.service';

@Pipe({
  name: 'crmActivityEffectiveDate',
  standalone: true,
})
export class CrmActivityEffectiveDatePipe implements PipeTransform {
  private readonly fieldService? = inject(CrmFieldService);

  transform(activity?: ActivityInterface): Date | null {
    if (!activity || !this.fieldService) {
      return null;
    }
    return (
      this.fieldService.getFieldValueFromCrmObject(activity, SystemFieldIds.ActivityEffectiveDate)?.dateValue ?? null
    );
  }
}
